/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactTypeWithRelations } from '../../models/contact-type-with-relations';

export interface GetContactTypeList$Params {
}

export function getContactTypeList(http: HttpClient, rootUrl: string, params?: GetContactTypeList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactTypeWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getContactTypeList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactTypeWithRelations>>;
    })
  );
}

getContactTypeList.PATH = '/contact-types';
